// extracted by mini-css-extract-plugin
export default {"formFundraiserContainer":"formFundraiserContainer__formFundraiserContainer--J5wOu"};